import { featureFlags } from "../configuration/featureFlags"

export function useFeatureFlag(flag: keyof typeof featureFlags) {
    return featureFlags[flag]
}